import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'

// import { authReducer, lotsReducer, ownersReducer, occursReducer, settingsReducer } from './reducers'
import { authReducer, formReducer } from './reducers'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const myStore = () => {
  const store = createStore(
    combineReducers({
      auth: authReducer,
      // lots: lotsReducer,
      // owners: ownersReducer,
      // occurs: occursReducer,
      form: formReducer,
    }),
    composeEnhancers(applyMiddleware(thunk))
    );

    if (process.env.NODE_ENV !== 'production') {
      if (module.hot) {
        module.hot.accept('./reducers', () => {
          store.replaceReducer(authReducer)
          // store.replaceReducer(lotsReducer)
          // store.replaceReducer(ownersReducer)
          // store.replaceReducer(occursReducer)
          store.replaceReducer(formReducer)
        })


      }
    }


  return store
}

export default myStore
